const initialState = {}

const appendedTeams = (teams, team) => {
  return [ team, ...teams ]
}

const releasedTeams = (teams, id) => {
  const teamIndex = teams.findIndex((team) => { return team.id == id })
  return [
    ...teams.slice(0, teamIndex), 
    ...teams.slice(teamIndex + 1, teams.length)
  ]
}

const updatedTeams = (teams, team) => {
  const index = teams.findIndex(l => l.id == team.id)
  return [
    ...teams.slice(0, index), 
    team,
    ...teams.slice(index + 1, teams.length)
  ]
}

const updatedGames = (games, game) => {
  const index = games.findIndex(g => g.id == game.id)
  return [
    ...games.slice(0, index),
    game,
    ...games.slice(index + 1, games.length)
  ]
}

const league = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'LEAGUE.INIT':
      return {...state, ...payload, currentTab: 'Teams'}
    case 'LEAGUE.CHANGE_TAB':
      return {...state, currentTab: payload}
    case 'LEAGUE.UPDATE_DATA':
      return {...state, data: payload}
    case 'LEAGUE.ADD_TEAM':
      return {...state, teams: appendedTeams(state.teams, payload)}
    case 'LEAGUE.DELETE_TEAM':
      return {...state, teams: releasedTeams(state.teams, payload)}
    case 'LEAGUE.UPDATE_TEAM':
      return {...state, teams: updatedTeams(state.teams, payload)}
    case 'LEAGUE.CREATE_SCHEDULE':
      return {...state, schedule: payload}
    case 'LEAGUE.CREATE_GAMES':
      return {...state, games: [...state.games, ...payload]}
    case 'LEAGUE.UPDATE_GAME':
      return {...state, games: updatedGames(state.games, payload)}
    case 'LEAGUES.CLOSED':
      return {...state, data: {...state.data, closed: true}}
    default:
      return state
  }
}

export default league
